// files-drawer.styled.ts
import styled from "@emotion/styled";
import { COLORS } from "../header/header.styled";

export const SearchBarRow = styled.div`
`;

export const AnimatedSheet = styled.div<{ active: boolean; top: number }>`
    position: absolute;
    left: 0;
    right: 0;
    top: ${({ top }) => `${top}px`};
    bottom: 0;

    display: flex;
    flex-direction: column;
    overflow: auto;
    padding-bottom: var(--keyboard-height-final, 0px);

    border-top: 1px solid #2b2d33;
    background: ${COLORS.surface};
    transform: translateY(${({ active }) => (active ? "0" : "-8px")});
    opacity: ${({ active }) => (active ? 1 : 0)};
    pointer-events: ${({ active }) => (active ? "auto" : "none")};
    transition:
        transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1),
        opacity 180ms linear;
    contain: paint;
`;

/** Grid wrapper inside the existing HeaderBar to guarantee true centering */
export const HeaderGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    width: 100%;
    gap: 8px;
    border-bottom: 1px solid #2b2d33;
`;

/** Center title that doesn't steal pointer events */
export const CenterTitle = styled.div`
    grid-column: 2 / 3;
    justify-self: center;
    pointer-events: none;
`;

export const HeaderTitleText = styled.div`
    font-family: Inter;
    font-weight: 600;
    font-style: Semi Bold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 140%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #e9ecf5;
`;

/** Right actions live in the third column and align to end */
export const RightActions = styled.div`
    grid-column: 3 / 4;
    justify-self: end;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SectionHeader = styled.div<{ first?: boolean }>`
    font-family: Inter;
    font-weight: 500;
    font-size: 14px;
    line-height: 19.6px;
    color: #b7bdcb;
    padding-bottom: 8px;
    ${({ first }) => !first && "padding-top: 24px;"}
`;

export const MostRecent = styled.div`
    font-family: Inter;
    font-weight: 500;
    font-size: 14px;
    line-height: 19.6px;
    color: #b7bdcb;
    padding-bottom: 8px;
`;

export const ConversationItBelongs = styled.div`
    font-family: Inter;
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    color: #b7bdcb;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 70%;
`;

export const FileDate = styled.div`
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 120%;
    letter-spacing: 0px;
    vertical-align: middle;
`;

export const FileNameWrap = styled.div`
    display: flex;
    min-width: 0;
    max-width: 200px;
`;

export const FileNameStem = styled.span`
    font-family: Inter;
    font-weight: 600;
    font-size: 15px;
    line-height: 140%;
    color: #e9ecf5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
`;

export const FileNameExt = styled.span`
    font-family: Inter;
    font-weight: 600;
    font-size: 15px;
    line-height: 140%;
    color: #e9ecf5;
    white-space: nowrap;
    flex-shrink: 0;
`;

export const FileName = styled.div`
    font-family: Inter;
    font-weight: 600;
    font-size: 15px;
    line-height: 140%;
    color: #e9ecf5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
`;

export const ThumbnailWrap = styled.div`
    position: relative;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    background: #2b2d33;
`;

export const ThumbnailImg = styled.img`
    display: block;
    width: 100%;
    max-height: 180px;
    object-fit: cover;
    border-radius: 10px;
`;

export const ThumbnailVideo = styled.video`
    display: block;
    width: 100%;
    max-height: 180px;
    border-radius: 10px;
    background: #000;
`;

export const VideoPlayOverlay = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
`;

export const ThumbnailShimmer = styled.div`
    width: 100%;
    height: 120px;
    border-radius: 10px;
    background: linear-gradient(90deg, #2b2d33 25%, #35373f 50%, #2b2d33 75%);
    background-size: 200% 100%;
    animation: shimmer 1.4s ease-in-out infinite;

    @keyframes shimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }
`;

/** ===== Inline-Styles -> Emotion (no visual changes) ===== */
export const BellWrap = styled.div`
    position: relative;
    display: inline-block;
`;

export const BellImg = styled.img`
    display: block;
`;

export const BellDot = styled.span`
    position: absolute;
    top: 12px;
    right: -4px;
    width: 11px;
    height: 11px;
    border-radius: 999px;
    background: #5e84ed;
`;

export const CloseImg = styled.img`
    width: 44px;
    height: 44px;
`;

export const ProfileImg = styled.img`
    width: 29px;
    height: 29px;
    border-radius: 19px;
    margin-bottom: 4px;
`;

/** Non-search (Most recent) wrappers */
export const NonSearchContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: #b7bdcb;
    padding-bottom: 32px;
`;

export const NonSearchListWrap = styled.div`
    margin-top: 12px;
`;

export const NonSearchItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 52px;
    padding: 8px 4px;
    overflow: hidden;
    border-radius: 12px;
`;

/** Middle column: file name stacked on top of metadata */
export const FileItemContent = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
`;

/** File name — wraps to 2 lines, then truncates */
export const FileItemName = styled.div`
    color: #e9ecf5;
    font-family: Inter;
    font-weight: 500;
    font-size: 14px;
    line-height: 16.8px;
    word-wrap: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

/** Metadata line: sender • date */
export const FileItemMeta = styled.div`
    color: #b7bdcb;
    font-family: Inter;
    font-weight: 500;
    font-size: 13px;
    line-height: 18.2px;
`;

/** Circular dots button */
export const DotsButton = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
`;

/** Icon wrapper on the left */
export const FileIconWrap = styled.div`
    padding: 2px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const RowBetween = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const FileRowLeft = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0;
`;

export const FileIcon = styled.img`
`;

export const SearchSheetInner = styled.div`
    padding: 12px; /* padding for searched files container */
`;

export const LoadMoreSentinel = styled.div`
    height: 1px;
    width: 100%;
`;

export const LoadingMoreText = styled.div`
    font-family: Inter;
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    color: #b7bdcb;
    text-align: center;
    padding: 16px 0;
`;

export const Divider = styled.div`
    border-bottom: 1px solid #2b2d33;
`;

/* ── Staggered fade-in for file items ── */
export const FadeInItem = styled.div<{ delay: number }>`
    opacity: 0;
    transform: translateY(12px);
    animation: fadeSlideIn 320ms ease-out forwards;
    animation-delay: ${({ delay }) => delay}ms;

    @keyframes fadeSlideIn {
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

/* ── Lightbox styles ── */
export const LightboxOverlay = styled.div`
    position: fixed;
    inset: 0;
    @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
    background: #000;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: calc(env(safe-area-inset-top, 0px) + 56px);
    padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 72px);
    padding-left: env(safe-area-inset-left, 0px);
    padding-right: env(safe-area-inset-right, 0px);
    animation: lbFadeIn 200ms ease-out;
    cursor: pointer;
    pointer-events: auto;

    @keyframes lbFadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
`;

export const LightboxImg = styled.img`
    max-width: 92vw;
    max-height: 100%;
    object-fit: contain;
    border-radius: 8px;
    user-select: none;
    cursor: default;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 0 40px rgba(255, 255, 255, 0.05);
`;

export const LightboxClose = styled.button`
    position: absolute;
    top: calc(env(safe-area-inset-top, 0px) + 12px);
    right: 12px;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.12);
    color: #e9ecf5;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Inter;
    font-weight: 600;
    line-height: 0;
    z-index: 1;

    &:active {
        background: rgba(255, 255, 255, 0.2);
    }
`;

export const LightboxDownload = styled.button`
    position: absolute;
    bottom: calc(env(safe-area-inset-bottom, 0px) + 20px);
    right: 20px;
    padding: 8px 16px;
    border: none;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(4px);
    color: #e9ecf5;
    font-size: 14px;
    font-family: Inter;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;

    &:active {
        background: rgba(255, 255, 255, 0.2);
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const LightboxFileName = styled.div`
    position: absolute;
    bottom: calc(env(safe-area-inset-bottom, 0px) + 24px);
    left: 20px;
    font-family: Inter;
    font-weight: 500;
    font-size: 14px;
    color: #b7bdcb;
    max-width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
